import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { postForm, errorMessage } from "@/lib/api";

export const Newsletter = ({ source = "footer", dark = true, testId = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await postForm("/newsletter", { email, source });
      toast.success(res.data?.already ? "You're already on the list." : "You're in! Fresh sips headed your way.");
      setEmail("");
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={`${testId}-form`} className={`flex w-full items-center gap-2 rounded-full p-1.5 ${dark ? "bg-white/10" : "bg-white"}`}>
      <label htmlFor={`${testId}-email`} className="sr-only">Email address</label>
      <input
        id={`${testId}-email`}
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@email.com"
        data-testid={`${testId}-email-input`}
        className={`min-w-0 flex-1 bg-transparent px-4 py-2.5 text-base focus:outline-none ${dark ? "text-[#fff5e8] placeholder:text-[#fff5e8]/55" : "text-[#1a0a10] placeholder:text-[#1a0a10]/45"}`}
      />
      <button type="submit" disabled={busy} data-testid={`${testId}-submit-btn`} className="btn btn-berry shrink-0 px-5 py-3 disabled:opacity-60">
        {busy ? "Joining…" : "Join"} <ArrowRight className="h-4 w-4" />
      </button>
    </form>
  );
};
